export default __webpack_public_path__ + "static/media/Maria_luisa_vasquez_coda.131617a7.jpeg";